export enum FeatureIds {
  USER_PANEL_SIGNUP = "mobility-item-page.user-panel-signup",
  DEALER_INFO_CARD_HOMEPAGE_SURVEY = "mobility-item-page.dealer-info-card-homepage-survey",
  ENABLE_CAR_RESERVATION_CTA = "mobility-item-page.enable-car-reservation-cta",
  ENABLE_INLINE_FEEDBACK_FORM = "mobility-item-page.enable-inline-feedback-form",
  ENABLE_EXPERT_CAR_REVIEW = "mobility-item-page.enable-expert-car-review",
}

export type FeatureToggles = Record<FeatureIds, boolean>;
